import {Component, OnInit} from '@angular/core';
import Swal from "sweetalert2";
import { BsModalService } from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import * as XLSX from "xlsx";
import {DatePipe} from "@angular/common";
import { Observable } from 'rxjs';
import { IPost, Post } from '../../../../../../models/post.model';
import { Product } from '../../../../../../models/product.model';
import { Note } from '../../../../../../models/avis.model';
import { Param } from '../../../../../../models/param.model';
import { ProductService } from '../../../../../../services/product.service';
import { PublicationService } from '../../../../../../services/publication.service';
import { ServiceService } from '../../../../../../services/service.service';
import { ParamService } from '../../../../../../services/param.service';
import { PostPromoteService } from '../../../../../../services/postPromote.service';
import { environment } from '../../../../../../environments/environment';
import { AddPromoteComponent } from '../../post-promote/add-promote/add-promote.component';
import { EncryptionService } from '../../../../../../services/EncryptionService';
import { SharedFonctionsService } from '../../../../../../services/shared-fonctions.service';

@Component({
  selector: 'app-employe-offer-published',
  templateUrl: './employe-offer-published.component.html',
  styleUrls: ['./employe-offer-published.component.scss']
})
export class EmployeOfferPublishedComponent implements OnInit {

  isFiltreDate: boolean;
  posts: Post[] = [];
  postTampons: Post[] = [];
  initialPosts: Post[] = [];
  perPage: number = 10;
  totalItems: number = 0;
  currentPage: number = 1;
  totalPages!: number;
  //@ts-ignore
  page:number=1;
  imageName: string | undefined = '';
  post!: Post;
  product!: Product;
  postUpdate!: Post;
  nbTotalPurchase: number = 0;
  url_photo: String;
  selected: boolean = false;
  unitTime: string [] = [];
  notePosts: Note[] = [];
  isHighlighted$: Observable<boolean>;
  search: any;
  postId: number;
  allowDeliveryChecked: boolean = false;

  sharedIdShop : any;

    // @ts-ignore
    public modalRef: BsModalRef;
  highlightedPosts:any[] = [];
  param: Param;
  paramPromo: Param;
  annonceEnPromotionDeKahpoo:any[] = [];
  kahooProductPromotionId :any;
  kahooServicePromotionId :any;
  constructor(private postService: PublicationService,
              private productService: ProductService,
              private servService:ServiceService,
              private fb: FormBuilder,private sharedSevice: SharedFonctionsService,
              private router: Router,private encryptionService: EncryptionService,
              private modalService: BsModalService,
              private datePipe: DatePipe, private paramService: ParamService, private postPromoteService: PostPromoteService) {
    this.unitTime = ['Minutes', 'Heurs', 'Jours', 'Mois'];
  }

  ngOnInit(): void {
    this.allPosts();
    this.url_photo = environment.url_photo;
    this.testIfIsKahpooProductPromotion();
    this.testIfIsKahpooServicePromotion();
    this.annoneMiseEnAvant();
    this.listeAnnoncesEnPromotionDeKahpoo();

   // this.isHighlighted$ = this.isIdInHighlightedPostsNew(this.postId);

  }

  dateForm = this.fb.group({
    beginDate: ['', Validators.required],
    endDate: ['', Validators.required]
  })

  updateProdFormGroup = this.fb.group({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    /*allowDelivery: new FormControl(null),
    pickFormShop: new FormControl(null),
    unitDeliveryDuration: new FormControl(''),
    deliveryDelay: new FormControl(''),*/
  });

  updateServFormGroup = this.fb.group({
    /*price: new FormControl('', [Validators.required]),*/
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required])
  });

  testIfIsKahpooProductPromotion():number{
    this.postService.isKahpooProductPromotion().subscribe(rs=>{
      if(rs){
        this.kahooProductPromotionId = rs?.id;
      }else{
        window.localStorage.removeItem("csa-tabbed-prowsing");
      }
    })
    return this.kahooProductPromotionId;
  }

  testIfIsKahpooServicePromotion(){
    this.postService.isKahpooServicePromotion().subscribe(rs=>{
      if(rs){
        this.kahooServicePromotionId = rs?.id;
      }else{
        window.localStorage.removeItem("csa-tabbed-srowsing");
      }

    })
  }

  jobApplyid ?: number;
  jobApplyname ?: string;
  shareJobApply(jobApply : any){
    //console.log("Détail de jobApply ....");
    //console.log(jobApply);
    this.jobApplyid = jobApply?.id;
    this.jobApplyname = jobApply?.title;
    if(this.jobApplyid != undefined && this.jobApplyname != undefined){
      const data  = undefined ? '' : JSON.stringify(this.jobApplyid);
      const data1  = undefined ? '' : JSON.stringify(this.jobApplyname);
      const datacryt = this.encryptionService.encryptionAES(data);
      const datacryt1 = this.encryptionService.encryptionAES(data1);
      window.localStorage.setItem('khjobApplyid!#',datacryt);
      window.localStorage.setItem('khjobApplyname!#',datacryt1);
      this.sharedSevice.jobApplyidshared = this.jobApplyid;
      this.sharedSevice.jobApplynameshared = this.jobApplyname;
    }
    // alert(this.jobApplyid)
  }

  allPosts() {
    this.postService.allEmployeJobPosts(0,200).subscribe((data :any) => {
      this.posts = data.content;
      this.totalItems = data.totalElements;
      //console.log("Liste des publications...")
      //console.log(this.posts)
      this.posts = this.filterByGiftCard(this.posts);
      this.initialPosts = this.posts;
      this.postTampons = this.posts;
      this.isFiltreDate = false;
     // this.postId = this.posts.map(post => post.id); // Suppose que post a un attribut id


    })
  }

  filterByGiftCard(publications: any[]): any[] {
    return publications.filter(pub => pub?.category?.name != 'Carte cadeaux');
  }

  enablePost(postId: number) {
    this.postService.enablePost(postId).subscribe(data => {
      //console.log("data.........................");
      //console.log(data);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.allPosts();
      this.reloadComponent();
    }, error => {
      //console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication"',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  disablePost(postId: number) {
    this.postService.disablePost(postId).subscribe(data => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Publication modifiée avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.allPosts();
      this.reloadComponent();
    }, error => {
     // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication"',
        showConfirmButton: false,
        timer: 1500
      });
    })
  }

  postDetails(p: Post) {
    //console.log(p);
    this.postService.totalPurchase(p.id).subscribe(data => {
      this.nbTotalPurchase = data;
    }, error => {
      //console.log(error);
    });

    this.postService.getIdPost(p.id).subscribe(post =>{
      this.post = post;
    });

    // Récupérer le détail de l'annonce
    if (p.postSubProducts.length > 0) {
      this.productService.getSubProductbyProductId(p.postSubProducts[0].subProduct.subProductID).subscribe(value => {
        this.product = value;
      })
    }


    this.getNotesAndCommentByPostId(p.id);
  }

  getNotesAndCommentByPostId(id: number){
    this.postService.notesAndCommentsByPostId(id).subscribe(data => {
      this.notePosts = data;
    }, error => {
     // console.log(error);
    })
  }

  productUpdated  :Product;
  serviceUpdated  :any;
  handleUpdate(id: number) {

    this.postService.getPostById(id).subscribe(rs => {
      this.postUpdate = rs;

     // console.log("Annonce à modifier début.....");
     // console.log(this.postUpdate);
      // console.log("Id du produit à modifier")
      // console.log(this.postUpdate.postSubProducts[0].subProduct.productID);
      // this.productService.getProductbyProductId(this.postUpdate.postSubProducts[0].subProduct.productID).subscribe(product => {
      if(this.postUpdate.postSubProducts.length>0){
        this.productService.getProductbyProductId(this.postUpdate.postSubProducts[0].subProduct.productID).subscribe(product => {


          this.productService.getIdProduct(product.id).subscribe(rs=>{
            this.productUpdated = rs;
            //console.log("Annonce à modifier .....");
           // console.log(this.productUpdated);

            // if (this.postUpdate.postProducts.length > 0) {
            //   this.updateProdFormGroup.patchValue({
            //     /*price: post.postProducts[0].price,*/
            //     description: this.postUpdate.description
            //   });
            // }
            if (this.postUpdate && this.productUpdated) {
              this.updateProdFormGroup.patchValue({
                /*price: post.postProducts[0].price,*/
                name: this.productUpdated.name,
                description: this.postUpdate.description
              });
            }
          })

        });
      }
      if (this.postUpdate.postServiceModels.length > 0) {
        this.serviceUpdated = this.postUpdate.postServiceModels[0].serviceModel;

        this.updateServFormGroup.patchValue({
          /*price: post.postServiceModels[0].price,*/
          name: this.postUpdate.postServiceModels[0].serviceModel.titre,
          description: this.postUpdate.description
        });
      }
    })
  }

  updatePubProd() {
    const name = this.updateProdFormGroup.get(['name']).value;
    const description = this.updateProdFormGroup.get(['description']).value;

    /*const allowDelivery = this.updateProdFormGroup.get(['allowDelivery']).value;
    const pickFormShop = this.updateProdFormGroup.get(['pickFormShop']).value;
    const unitDeliveryDuration = this.updateProdFormGroup.get(['unitDeliveryDuration']).value;
    const deliveryDelay = this.updateProdFormGroup.get(['deliveryDelay']).value;*/

    /*if (this.allowDeliveryChecked && unitDeliveryDuration == null && this.allowDeliveryChecked && deliveryDelay == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner l\'unité de temps et le délais de livraison',
        showConfirmButton: false,
        timer: 1500
      });
    } else if (this.allowDeliveryChecked && deliveryDelay == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez remplir le délais de livraison',
        showConfirmButton: false,
        timer: 1500
      });
    } else if (this.allowDeliveryChecked && unitDeliveryDuration == null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir l\'unité de temps',
        showConfirmButton: false,
        timer: 1500
      });
    }*/

    let post: IPost = this.postUpdate;
    post.description = description;
    //post.postProducts[0].price = price;
    this.productUpdated.name = name;
    this.postService.updatePost(post).subscribe(data => {

     // console.log("Validation du produit à modifier");
      //console.log(this.productUpdated)

      this.productService.updateProduct(this.productUpdated).subscribe(rs=>{
       // console.log("Modificationnnnnnnnnnnnnnnnnnnnnnnnnnnnnn");
        //console.log(rs);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Publication modifiée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      })

    }, error => {
      //console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication',
        showConfirmButton: false,
        timer: 1500
      });
    });
  }

  updateServPub() {
    //const price = this.updateServFormGroup.get(['price']).value;
    const name = this.updateServFormGroup.get(['name']).value;
    const description = this.updateServFormGroup.get(['description']).value;

    let post: IPost = this.postUpdate;
    // post.postServiceModels[0].price = price;
    post.description = description;
    this.serviceUpdated.titre = name;
   // console.log("Post Service modifier ...");
    //console.log(post);
    this.postService.updatePost(post).subscribe(data => {
     // console.log("postdata updated");
     // console.log(data);
      this.servService.updateService(this.serviceUpdated).subscribe(rs=>{
       // console.log("Service qu'on a modifier...");
       // console.log(rs);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Publication modifiée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      });
    }, error => {
      // console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur lors de la modification de la publication',
        showConfirmButton: false,
        timer: 1500
      });
    });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  /*hideDeliveryDayAndUnitTime() {
    this.allowDeliveryChecked = false;
  }*/

  /*showDeliveryDayAndUnitTime() {
    this.allowDeliveryChecked = true;
  }*/

  // Vérifier si l'id se trouve la liste des annonces que Kahpoo à mis en promotion
  isIdInPromotionPosts(id: number): boolean {
    return this.annonceEnPromotionDeKahpoo.includes(id);
  }

  // Récupérer la liste des annonces en promotion faite par kahpoo
  listeAnnoncesEnPromotionDeKahpoo(): number[] {
        this.paramPromo =  new Param();
        this.paramService.getParamBySlug("promotion-kahpoo").subscribe(rs=>{
          this.paramPromo = rs;
          let paramValue = this.paramPromo?.value;

          if (paramValue !== null && paramValue !== undefined && paramValue.trim() !== "") {
              const idStrings: string[] = paramValue.split(",");
              for (const idString of idStrings) {
                  if (idString.trim() !== "") {
                      try {
                          const postId: number = parseInt(idString.trim(), 10);
                          this.annonceEnPromotionDeKahpoo.push(postId);
                      } catch (e) {
                      }
                  }
              }
          }
        });

        //console.log("Annonce mise promotion de kahpoo ..........");
        //console.log(this.annonceEnPromotionDeKahpoo);
        return this.annonceEnPromotionDeKahpoo;
  }

  // annoneMiseEnAvantOld(): number[] {
  //       this.param =  new Param();
  //       this.paramService.getParamBySlug("post-mise-en-avant").subscribe(rs=>{
  //         this.param = rs;
  //         let paramValue = this.param?.value;

  //         if (paramValue !== null && paramValue !== undefined && paramValue.trim() !== "") {
  //             const idStrings: string[] = paramValue.split(",");
  //             for (const idString of idStrings) {
  //                 if (idString.trim() !== "") {
  //                     try {
  //                         const postId: number = parseInt(idString.trim(), 10);
  //                         this.highlightedPosts.push(postId);
  //                     } catch (e) {
  //                     }
  //                 }
  //             }
  //         }
  //       });

  //       console.log("Annonce mise en avant Old..........");
  //       console.log(this.highlightedPosts);
  //       return this.highlightedPosts;
  // }

  annoneMiseEnAvant(): number[] {

    this.postPromoteService.getListPostIdPromote().subscribe(rs=>{
     // console.log("liii moy rs", rs);
      if (rs !== null && rs !== undefined) {
        this.highlightedPosts = rs
        //console.log("liii moy highlightedPosts", this.highlightedPosts);
     }
    });


    return this.highlightedPosts;
}

  isIdInHighlightedPosts(id: number): boolean {
    return this.highlightedPosts.includes(id);
  }

  isIdInHighlightedPostsNew(id: number): Observable<boolean> {
    return this.postPromoteService.isIdInHighlightedPosts(id);
  }

  mettreEnPromotion(p: any) {
    //console.log(p);
    if(p.status?.name === "publié"){
      if((p.postSubProducts.length > 0 && this.kahooProductPromotionId) || (p.postServiceModels.length > 0 && this.kahooServicePromotionId)){
        Swal.fire({
          title: 'Voulez-vous ajouter cette annonce en promotion ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonText: 'Non',
          confirmButtonText: 'Oui'
        }).then((result) => {
          if (result.isConfirmed) {
            if (!this.isIdInPromotionPosts(p.id)){
              this.annonceEnPromotionDeKahpoo.push(p.id);
              const value: string = this.annonceEnPromotionDeKahpoo.join(',');
              //console.log("Nouvelle liste");
              //console.log(value);
              this.paramPromo.value = value;
              this.paramService.updateParam(this.paramPromo).subscribe(rs=>{
                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: 'La publication a été ajoutée à la liste des annonces en promotion.',
                  showConfirmButton: false,
                  timer: 1500
                });
                this.reloadComponent();
              }, error => {
                  Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.error.errorMessage,
                    showConfirmButton: false,
                    timer: 1500
                  })
                });
            }else{
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: 'Cette annonce est déjà dans la liste des annonces en promotion.',
                showConfirmButton: false,
                timer: 1500
              })
            }
          }
        });
      }else if(p.postSubProducts.length > 0 && (!this.kahooProductPromotionId || this.kahooProductPromotionId==undefined)){
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veillez d\'abord activé une promotion de type produit.',
          showConfirmButton: false,
          timer: 2500
        })
      }else if(p.postServiceModels.length > 0 && (!this.kahooServicePromotionId || this.kahooServicePromotionId==undefined)){
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veillez d\'abord activé une promotion de type service.',
          showConfirmButton: false,
          timer: 2500
        })
      }
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veillez d\'abord activé la publication.',
        showConfirmButton: false,
        timer: 2500
      })
    }

  }

  // mettreEnAvant(p: any) {
  //   if(p.status?.name === "publié"){
  //     Swal.fire({
  //       title: 'Voulez-vous mettre en avant cette annonce ?',
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonText: 'Non',
  //       confirmButtonText: 'Oui'
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         if (!this.isIdInHighlightedPosts(p.id)){
  //           this.highlightedPosts.push(p.id);
  //           const value: string = this.highlightedPosts.join(',');
  //           console.log("Nouvelle liste");
  //           console.log(value);
  //           this.param.value = value;
  //           this.paramService.updateParam(this.param).subscribe(rs=>{
  //             Swal.fire({
  //               position: 'top-end',
  //               icon: 'success',
  //               title: 'La publication a été mise en avant avec succès.',
  //               showConfirmButton: false,
  //               timer: 1500
  //             });
  //             this.reloadComponent();
  //           }, error => {
  //               Swal.fire({
  //                 position: 'top-end',
  //                 icon: 'error',
  //                 title: error.error.errorMessage,
  //                 showConfirmButton: false,
  //                 timer: 1500
  //               })
  //             });
  //         }else{
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'error',
  //             title: 'Cette annonce est déjà mis en avant.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           })
  //         }
  //       }
  //     });
  //   }else{
  //     Swal.fire({
  //       position: 'top-end',
  //       icon: 'error',
  //       title: 'Veillez d\'abord activé la publication.',
  //       showConfirmButton: false,
  //       timer: 2500
  //     })
  //   }
  // }

  mettreEnAvant(p: any) {
    if(p.status?.name === "publié"){
      Swal.fire({
        title: 'Voulez-vous mettre en avant cette annonce ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonText: 'Non',
        confirmButtonText: 'Oui'
      }).then((result) => {
        if (result.isConfirmed) {
          if (!this.isIdInHighlightedPosts(p.id)){
            this.postPromoteService.enablePromoteByPostId(p.id).subscribe(rs=>{
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'La publication a été mise en avant avec succès.',
                showConfirmButton: false,
                timer: 1500
              });
              this.reloadComponent();
            }, error => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: error.error.errorMessage,
                  showConfirmButton: false,
                  timer: 1500
                })
              });
          }else{
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Cette annonce est déjà mis en avant.',
              showConfirmButton: false,
              timer: 1500
            })
          }
        }
      });
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veillez d\'abord activé la publication.',
        showConfirmButton: false,
        timer: 2500
      })
    }
  }

  enleverDeLaListeDesAnnoncesMisEnPromotion(id: number) {
    Swal.fire({
      title: 'Voulez-vous l\'enlever de la liste des annonces mise en promotion ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        const index = this.annonceEnPromotionDeKahpoo.indexOf(id);
        if (index !== -1) {
          this.annonceEnPromotionDeKahpoo.splice(index, 1);
          const value: string = this.annonceEnPromotionDeKahpoo.join(',');
          // console.log("Nouvelle liste");
          // console.log(value);
          this.paramPromo.value = value;
          this.paramService.updateParam(this.paramPromo).subscribe(rs=>{
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'La publication a été enlevée dans la des annonces mise en promotion.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 1500
              })
          });
        }
      }
    });
  }

  // enleverDeLaListeDesAnnoncesMisEnAvant(id: number) {
  //   Swal.fire({
  //     title: 'Voulez-vous l\'enlever de la liste des annonces mise en avant ?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonText: 'Non',
  //     confirmButtonText: 'Oui'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const index = this.highlightedPosts.indexOf(id);
  //       if (index !== -1) {
  //         this.highlightedPosts.splice(index, 1);
  //         const value: string = this.highlightedPosts.join(',');
  //         console.log("Nouvelle liste");
  //         console.log(value);
  //         this.param.value = value;
  //         this.paramService.updateParam(this.param).subscribe(rs=>{
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'success',
  //             title: 'La publication a été enlevée dans la des annonces mise en avant avec succès.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           });
  //           this.reloadComponent();
  //         }, error => {
  //             Swal.fire({
  //               position: 'top-end',
  //               icon: 'error',
  //               title: error.error.errorMessage,
  //               showConfirmButton: false,
  //               timer: 1500
  //             })
  //         });
  //       }
  //     }
  //   });
  // }

  // enleverDeLaListeDesAnnoncesMisEnAvant(id: number) {
  //   Swal.fire({
  //     title: 'Voulez-vous l\'enlever de la liste des annonces mise en avant ?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonText: 'Non',
  //     confirmButtonText: 'Oui'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const index = this.highlightedPosts.indexOf(id);
  //       if (index !== -1) {
  //         // this.highlightedPosts.splice(index, 1);
  //         // const value: string = this.highlightedPosts.join(',');
  //         // console.log("Nouvelle liste");
  //         // console.log(value);
  //         // this.param.value = value;
  //         this.postPromoteService.deletePromoteFromPostId(id).subscribe(rs=>{
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'success',
  //             title: 'La publication a été enlevée dans la des annonces mise en avant avec succès.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           });
  //           this.reloadComponent();
  //         }, error => {
  //             Swal.fire({
  //               position: 'top-end',
  //               icon: 'error',
  //               title: error.error.errorMessage,
  //               showConfirmButton: false,
  //               timer: 1500
  //             })
  //         });
  //       }
  //     }
  //   });
  //}

  enleverDeLaListeDesAnnoncesMisEnAvant(id: number) {
    Swal.fire({
      title: 'Voulez-vous l\'enlever de la liste des annonces mise en avant ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromoteService.deletePromoteFromPostId(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'La publication a été enlevée dans la des annonces mise en avant avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            //console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }
  deletePost(id: number) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cette publication ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postService.deletePost(id).subscribe(
          rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Publication supprimée avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            //console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  raiseTableSize(event: any) {
    this.perPage = event.target.value;
    this.allPosts();
  }

  searchPost($event: KeyboardEvent) {
    this.posts = this.filterByGiftCard(this.postTampons).filter(value =>
      value?.title.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.description.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.status?.name.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      this.getProfilName(value).toLowerCase().includes(this.search.toLowerCase().trim()) ||
      this.getTypeContrat(value).toLowerCase().includes(this.search.toLowerCase().trim()) ||
      this.getPays(value).toLowerCase().includes(this.search.toLowerCase().trim()) ||
      this.getVille(value).toLowerCase().includes(this.search.toLowerCase().trim()) ||
      this.getEmail(value).toLowerCase().includes(this.search.toLowerCase().trim()) ||
      // this.getTypeContrat(value).toLowerCase().includes(this.search.toLowerCase().trim()) ||
      (Number(this.search) === value?.postServiceModels[0]?.finalPrice) ||
      value?.userID?.firstname.toLowerCase().includes(this.search.toLowerCase().trim()) ||
      value?.userID?.lastname.toLowerCase().includes(this.search.toLowerCase().trim())
    )
    // this.posts = this.filterByGiftCard(this.posts);
   // console.log(this.posts);
  }

  ascendingOrderByProductName: boolean = true;
  sortByProductName(){
    this.posts.sort((a, b) => {
      const nameA = a.title.toLowerCase();
      const nameB = b.title.toLowerCase();

      if(this.ascendingOrderByProductName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByProductName = !this.ascendingOrderByProductName;
  }

  ascendingProfilName: boolean = true;
  sortByProfilName() {
    this.posts.sort((a, b) => {
      const nameA = this.getProfilName(a);
      const nameB = this.getProfilName(b);
      if(this.ascendingProfilName){
        return nameA.localeCompare(nameB);
      }else{
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingProfilName = !this.ascendingProfilName;
  }

  ascendingOrderByTypeContrat: boolean = true;
  sortByTypeContrat(){
    this.posts.sort((a, b) => {
      const nameA = this.getTypeContrat(a);
      const nameB = this.getTypeContrat(b);

      if(this.ascendingOrderByTypeContrat){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByTypeContrat = !this.ascendingOrderByTypeContrat;
  }

  ascendingOrderByCountryName: boolean = true;
  sortByCountryName(){
    this.posts.sort((a, b) => {
      const nameA = this.getPays(a);
      const nameB = this.getPays(b);

      if(this.ascendingOrderByCountryName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCountryName = !this.ascendingOrderByCountryName;
  }

  ascendingOrderByCityName: boolean = true;
  sortByCityName(){
    this.posts.sort((a, b) => {
      const nameA = this.getVille(a);
      const nameB = this.getVille(b);

      if(this.ascendingOrderByCityName){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByCityName = !this.ascendingOrderByCityName;
  }

  ascendingOrderPhoneNumber: boolean = true;
  sortByPhoneNumber() {
    this.posts.sort((a, b) => {
      const mobileA = this.getPhoneNumber(a);
      const mobileB = this.getPays(b);
      if(this.ascendingOrderPhoneNumber){
        return mobileA.localeCompare(mobileB);
      }else{
        return mobileB.localeCompare(mobileA);
      }
    })
    this.ascendingOrderPhoneNumber = !this.ascendingOrderPhoneNumber;
  }

  ascendingOrderByMail: boolean = true;
  sortByMail(){
    this.posts.sort((a, b) => {
      const nameA = this.getEmail(a);
      const nameB = this.getEmail(b);

      if(this.ascendingOrderByMail){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByMail = !this.ascendingOrderByMail;
  }

  ascendingOrderByLimitDate: boolean = true;
  sortByLimitDate(){
    this.posts.sort((a, b) => {
      const nameA = this.getLimitDate(a);
      const nameB = this.getLimitDate(b);

      if(this.ascendingOrderByLimitDate){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByLimitDate = !this.ascendingOrderByLimitDate;
  }
  sortByPublishedAt(){
    this.posts.sort((a, b) => {
      const nameA = a.publishedAt.toString();
      const nameB = b.publishedAt.toString();

      if(this.ascendingOrderByLimitDate){
        return nameA.localeCompare(nameB);
      }else {
        return nameB.localeCompare(nameA);
      }
    })
    this.ascendingOrderByLimitDate = !this.ascendingOrderByLimitDate;
  }

  filterByStatus(event: any) {
    let value: string = event.target.value;
    if (value == 'tous') {
      this.posts = this.initialPosts;
    } else {
      this.posts = this.initialPosts.filter(result => {
        return result.status.name.includes(value);
      })
    }
  }

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
   // console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  areDatesEmpty(): boolean {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    return !beginDate && !endDate;
  }

  filterByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;

    // Vérifier si les deux champs de date sont vides
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    } else {
      const beginDateISO = new Date(beginDate).toISOString();
      const endDateISO = new Date(endDate).toISOString();
      // console.log("Date sélectionnée")
      // console.log('beginDate:', beginDateISO);
      // console.log('endDate:', endDateISO);

      this.productService.getProductEmployeJobByDate(this.sharedIdShop, beginDateISO, endDateISO, this.page - 1, this.perPage).subscribe(data => {
        this.posts = data.content;
        this.totalItems = data.totalElements;
        //console.log("this.posts",this.posts)
        this.isFiltreDate = true
      });
    }
  }

  filterPostByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;
    if(beginDate == '' || endDate == ''){
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }

    let endDateTrans: any = new Date(endDate);
    endDateTrans.setDate(endDateTrans.getDate() + 1);
    endDateTrans = this.datePipe.transform(endDateTrans,'yyyy-MM-dd');
   // console.log(endDateTrans);

    this.posts = this.initialPosts.filter(p => {
      return (p.publishedAt >= beginDate) && (p.publishedAt <= endDateTrans);
    })
  }

  refresh() {
    this.allPosts();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  getUrlPhoto() {
    this.imageName = this.post.postSubProducts[0].subProduct?.photo;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto1() {
    if(this.post.postSubProducts[0].subProduct?.photo1)
    this.imageName = this.post.postSubProducts[0].subProduct?.photo1;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  getUrlPhoto2() {
    if(this.post.postSubProducts[0].subProduct?.photo2)
    this.imageName = this.post.postSubProducts[0].subProduct?.photo2;
    if(this.imageName != null || this.imageName != undefined){
      this.selected = true;
    }else {
      this.selected = false;
    }
  }

  postMiseEnAvant(posted:IPost){
    this.modalRef = this.modalService.show(AddPromoteComponent,{
      initialState:{posted},
      backdrop: false,
      ignoreBackdropClick: true
    });
  }
  // Profil recherché
  getProfilName(p): string | undefined {
    const name = "required.profile";
    if (p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics) {
        const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
        return characteristic ? characteristic.value : undefined;
    }
    return undefined;
  }

  // Type du contrat
  getTypeContrat(p): string | undefined {
    let name = "type.of.contract";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Pays
  getPays(p): string | undefined {
    let name = "contract.country";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Ville
  getVille(p): string | undefined {
    let name = "contract.city";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Numéro de téléphone
  getPhoneNumber(p): string | undefined {
    let name = "phone.number";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // E- mail
  getEmail(p): string | undefined {
    let name = "email.contact";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Date limite de l’offre
  getLimitDate(p): string | undefined {
    let name = "offer.deadline";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  // Présentation de l'entreprise
  entreprisePresentation(p): string | undefined {
    let name = "company.presentation";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  //Description de l'offre
  offerDescription(p): string | undefined {
    let name = "description.of.the.offer";
    if(p.postSubProducts[0] && p.postSubProducts[0].subProduct.subProductCharacteristics){
      const characteristic = p.postSubProducts[0].subProduct.subProductCharacteristics.find(item => item.characteristic.name?.trim() === name);
      return characteristic ? characteristic.value : undefined;
    }
  }

  offerDetailsDisplayed :any;
  offerDetails(offer : any){
    this.offerDetailsDisplayed = offer;
    //console.log("Détail de l'offre ....");
    //console.log(this.offerDetailsDisplayed);
  }

pagination(){
  if(this.isFiltreDate){
    this.filterByDate()
  }
  else{
    this.allPosts()
  }

}

}
